import { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";

import { InfoBox } from "../core/InfoBox";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";

export const AdjustableLoadElectricInstallationAgreementForm: FC = () => {
    const { values, setValues } =
        useFormModel<ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_INSTALLATION_AGREEMENT>();
    return (
        <Fragment>
            <InfoBox style={{ marginTop: 40 }}>
                <p>
                    Die Elektroinstallation darf ausschließlich durch einen eingetragenen
                    Elektrofachbetrieb vorgenommen werden und die anerkannten Regeln der Technik,
                    insbesondere die VDE AR-N 4100 sowie die TAB Niederspannung der Syna GmbH, sind
                    einzuhalten.
                </p>

                <FormControlLabel
                    isCheckBox={true}
                    control={
                        <Checkbox
                            style={{ marginRight: 12 }}
                            value="ja"
                            checked={values.adjustableLoadElectricInstallationAgreement.value.yes}
                            onChange={(event, checked) =>
                                setValues((values) => {
                                    values.adjustableLoadElectricInstallationAgreement.value = {
                                        yes: checked,
                                        no: !checked,
                                    };
                                })
                            }
                        />
                    }
                    label="Die technischen Anforderungen habe ich gelesen und akzeptiere diese hiermit."
                    error={values.adjustableLoadElectricInstallationAgreement.error ? true : false}
                />
            </InfoBox>
        </Fragment>
    );
};
